import React from 'react';
import PropTypes from 'prop-types';
import { TeamTree } from 'components/page/index';
import { DefaultDepartment } from 'components/ui/index';


class Department extends React.Component {
    selectDepartment = (selectedKeys) => {
      this.props.setSelectedTeam(selectedKeys[0]);
    }

    render() {
      const {
        teams, setTeams, setSelectedTeam, handleDoubleClick
      } = this.props;
      return (
        <div>
          <DefaultDepartment onSelect={id => setSelectedTeam(id)} />
          {_.isFunction(handleDoubleClick) &&
            <TeamTree
              onSelect={selectedKeys => this.selectDepartment(selectedKeys)}
              teams={teams}
              setTeams={setTeams}
              onDbClick={(selectedKeys, name) => handleDoubleClick(selectedKeys, name)}
              defaultExpandAll
            />}
          {!_.isFunction(handleDoubleClick) &&
            <TeamTree
              onSelect={selectedKeys => this.selectDepartment(selectedKeys)}
              teams={teams}
              setTeams={setTeams}
              defaultExpandAll
            />}
        </div>
      );
    }
}
Department.defaultProps = {
  handleDoubleClick: null
};
Department.propTypes = {
  teams: PropTypes.array.isRequired,
  setTeams: PropTypes.func.isRequired,
  setSelectedTeam: PropTypes.func.isRequired,
  handleDoubleClick: PropTypes.func
};

export default Department;



// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/component/department.jsx